var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-btn',_vm._b({staticClass:"white--text",attrs:{"elevation":!_vm.hasElevation ? undefined : _vm.attrs.elevation}},'v-btn',Object.assign({}, _vm.attrs,
        {color: _vm.attrs.color || 'deep-purple accent-4'},
        ( _obj = {}, _obj[_vm.attrs.size] = true, _obj )),false),[(_vm.attrs.fab || _vm.attrs.icon)?_c('v-icon',[_vm._v("mdi-account")]):_c('span',[_vm._v("Click Me")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }